const A = ["BG_REMOVAL", "UPSCALE"], V = 100, k = 1e4, x = {
  BG_REMOVAL: "Background removal",
  UPSCALE: "Image enhancement"
}, q = "a1e0c0de-0000-4000-8000-000000000001", m = {
  BG_REMOVAL: "a1e0c0de-0000-4000-8000-000000000002",
  UPSCALE: "a1e0c0de-0000-4000-8000-000000000003"
}, Q = (e) => {
  for (const t of A)
    if (m[t] === e) return t;
  return null;
}, z = 50 * 1024 * 1024, K = "image/*", X = 150, I = 200, W = 3200, Z = 3200, J = 95, j = 300, ee = 300, te = 85, ne = 1500, se = 40, ae = 2e3, oe = /^https:\/\/(placehold\.co|via\.placeholder\.com)\/\d+(?:x\d+)?$/, ie = [
  "designAsset",
  "shape",
  "qrCode",
  "line",
  "watermark",
  "stylizedVerse",
  "logoImage",
  "floralPix"
], re = I, de = 36e6, _e = 3, le = 16383, ce = 18e4, Ee = {
  personalInfo: "personalInfo",
  familyInfo: "familyInfo",
  additionalFamily: "additionalFamily",
  serviceInfo: "serviceInfo",
  musicSelections: "musicSelections",
  pallBearersSocieties: "pallBearersSocieties",
  intermentInfo: "intermentInfo",
  memorialContributions: "memorialContributions",
  headers: "headers"
}, Ae = {
  prefix: "prefix",
  first: "first",
  nickname: "nickname",
  middle: "middle",
  last: "last",
  suffix: "suffix",
  maiden: "maiden"
}, me = {
  prefix: "Prefix",
  first: "First Name",
  nickname: '"Nickname"',
  middle: "Middle Name",
  last: "Last Name",
  suffix: "Suffix",
  maiden: "(Maiden Name)"
}, Ie = {
  sectionLabel: "sectionLabel",
  input: "input",
  date: "date",
  array: "array",
  mappedArray: "mappedArray",
  nestedArray: "nestedArray",
  textarea: "textarea",
  check: "check",
  blank: "blank"
}, Te = {
  sectionLabel: "section_label",
  editableCaseId: "editable_case_id",
  prefix: "prefix_dec",
  firstName: "first_dec",
  nickName: "nick_name_dec",
  middleName: "middle_dec",
  maidenName: "maiden_dec",
  lastName: "lastdec",
  // TODO: backend uses lastdec, so have to use this for now (should be last_dec)
  suffix: "suffix_dec",
  dateOfBirth: "date_of_birth",
  dateOfDeath: "date_of_death",
  placeOfBirth: "place_of_birth",
  placeOfDeath: "place_of_death",
  motherOfDeceased: "mother_of_deceased",
  fatherOfDeceased: "father_of_deceased",
  spouse: "spouse",
  dateOfMarriage: "date_of_marriage",
  siblings: "siblings",
  children: "children",
  additionalFamily: "additional_family",
  maternalGrandmother: "maternal_grandmother",
  maternalGrandmothersMother: "maternal_grandmothers_mother",
  maternalGrandmothersFather: "maternal_grandmothers_father",
  maternalGrandfather: "maternal_grandfather",
  maternalGrandfathersMother: "maternal_grandfathers_mother",
  maternalGrandfathersFather: "maternal_grandfathers_father",
  paternalGrandmother: "paternal_grandmother",
  paternalGrandmothersMother: "paternal_grandmothers_mother",
  paternalGrandmothersFather: "paternal_grandmothers_father",
  paternalGrandfather: "paternal_grandfather",
  paternalGrandfathersMother: "paternal_grandfathers_mother",
  paternalGrandfathersFather: "paternal_grandfathers_father",
  familyAppreciationMessage: "family_appreciation_message",
  services: "services",
  orderOfService: "order_of_service",
  clergy: "clergy",
  songs: "songs",
  pallbearers: "pallbearers",
  organizations: "organizations",
  memorialContributions: "memorial_contributions",
  intermentTime: "interment_time",
  intermentDate: "interment_date",
  intermentPlace: "interment_place",
  intermentAddress: "interment_address",
  intermentCity: "interment_city",
  intermentState: "interment_state",
  intermentPostalCode: "interment_postal_code",
  birthHeader: "case_preferences.birth_header",
  deathHeader: "case_preferences.death_header",
  remembranceHeader: "case_preferences.remembrance_header",
  officiatingHeader: "case_preferences.officiating_header",
  memorialServiceHeader: "case_preferences.memorial_service_header",
  pallbearersHeader: "case_preferences.pallbearers_header",
  visitationHeader: "case_preferences.visitation_header",
  finalRestingHeader: "case_preferences.final_resting_header",
  familyAppreciationHeader: "case_preferences.family_appreciation_header"
}, Oe = {
  personalInfo: "Personal Information",
  editableCaseId: "Custom case ID",
  prefix: "Prefix name",
  firstName: "First name",
  nickName: "Nickname",
  middleName: "Middle name",
  maidenName: "Maiden name",
  lastName: "Last name",
  suffix: "Suffix name",
  dateOfBirth: "Date of birth *",
  dateOfDeath: "Date of death",
  placeOfBirth: "Place of birth",
  placeOfDeath: "Place of death",
  parents: "Parents",
  motherOfDeceased: "Mother full name",
  fatherOfDeceased: "Father full name",
  spouse: "Spouse full name",
  dateOfMarriage: "Date of marriage",
  siblings: "Siblings",
  sibling: "Sibling",
  children: "Children",
  child: "Child",
  additionalFamily: "Additional Family",
  genealogy: "Genealogy",
  mothersSide: "Mother's Side",
  fathersSide: "Father's Side",
  grandmother: "Grandmother",
  grandfather: "Grandfather",
  greatGrandmother: "Great grandmother",
  greatGrandfather: "Great grandfather",
  grandmothersParents: "Grandmother's parents",
  grandfathersParents: "Grandfather's parents",
  precededBySurvivedByGrandchildren: "Preceded By, Survived By, Grandchildren etc.",
  addAnotherGroup: "Add Another Group",
  orderOfService: "Order of service",
  clergy: "Clergy",
  musicSelections: "Music Selections",
  song: "Song",
  intermentInfo: "Interment Info",
  intermentTime: "Interment Time",
  intermentDate: "Interment Date",
  intermentPlace: "Interment Place",
  intermentAddress: "Interment Address",
  intermentCity: "Interment City",
  intermentState: "Interment State",
  intermentPostalCode: "Interment Postal Code",
  birthHeader: "Date of Birth",
  deathHeader: "Date of Death",
  remembranceHeader: "Remembrance",
  officiatingHeader: "Officiating",
  memorialServiceHeader: "Memorial Service",
  pallbearersHeader: "Pallbearers Header",
  visitationHeader: "Visitation",
  finalRestingHeader: "Final Resting",
  familyAppreciationHeader: "Family Appreciation"
}, Se = {
  visitation: "visitation",
  service: "service",
  pallbearer: "pallbearer",
  honoraryPallbearer: "honorary pallbearer",
  organization: "organization",
  memorialContribution: "memorial contribution"
}, ue = {
  additionalFamily: ["name", "relation", "city", "state", "country"],
  services: [
    { field: "location", type: "input" },
    { field: "city", type: "input" },
    { field: "state", type: "input" },
    { field: "date", type: "date" },
    { field: "start_time", type: "input" },
    { field: "end_time", type: "input" },
    { field: "clergy_place", type: "input" },
    { field: "room_chapel", type: "input" },
    { field: "address", type: "input" },
    { field: "postal_code", type: "input" },
    { field: "country", type: "input" },
    { field: "default", type: "check" }
  ],
  pallbearers: [
    { field: "name", type: "input" },
    { field: "sequence", type: "input" }
  ],
  organizations: [
    { field: "name", type: "input" },
    { field: "address1", type: "input" },
    { field: "address2", type: "input" },
    { field: "city", type: "input" },
    { field: "state", type: "input" },
    { field: "zip_code", type: "input" },
    { field: "country", type: "input" },
    { field: "website_url", type: "input" },
    { field: "sequence", type: "input" }
  ],
  memorialContributions: [
    { field: "charity_of_choice", type: "check" },
    { field: "name", type: "input" },
    { field: "sequence", type: "input" }
  ]
}, pe = {
  service: {
    location: null,
    city: null,
    state: null,
    date: "",
    time: null,
    start_time: "",
    end_time: null,
    clergy_place: null,
    room_chapel: null,
    address: null,
    postal_code: null,
    country: null,
    default: !1
  },
  additionalFamily: {
    name: null,
    relation: null,
    city: null,
    state: null,
    country: null
  },
  pallbearers: {
    name: null,
    sequence: null
  },
  organizations: {
    name: null,
    address1: null,
    address2: null,
    city: null,
    state: null,
    zip_code: null,
    country: null,
    website_url: null,
    sequence: null
  },
  memorialContributions: {
    charity_of_choice: !1,
    name: null,
    sequence: null
  }
}, ge = {
  hidden: {
    sequence: "sequence"
  }
}, Ne = 300, fe = {
  DECEASED_INFO: "Deceased Info",
  OBITUARY: "Obituary",
  SERVICE_INFO: "Service Info",
  IMAGES_AND_FAMILY: "Images",
  CASE_PREFERENCES: "Case Preferences"
}, De = ["M3", "MDL"], Le = /^[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+$/, Re = "client-credentials", he = 3e4, Ce = 3e3, Pe = "M/D [at] h:mm a", T = "designRequestNotify", O = "rasterizeProofPdf", S = 25 * 1024 * 1024, d = S / (1024 * 1024), Me = 100, ye = (e) => `${O}:${e}`, Ue = 4e3, Fe = 3 * 6e4, Ge = (e) => `${T}:${e}`, ve = {
  title: "Designer Space",
  overview: "Overview",
  customDesigns: "Custom Designs",
  queue: "Queue",
  myItems: "My Inbox",
  qualityAssurance: "Quality Assurance",
  comingSoon: "Coming soon.",
  // Queue urgency pills, from the request's frozen need-by urgency.
  urgency: {
    LOW: "Low",
    MEDIUM: "Medium",
    HIGH: "High",
    RUSH: "Rush"
  },
  // Overview page
  greeting: "Hello",
  yourTasks: "Your Tasks",
  recentActivity: "Recent Activity",
  messages: "Messages",
  comments: "Comments",
  all: "All",
  unread: "Unread",
  previousPage: "Previous page",
  nextPage: "Next page",
  pageSummary: (e, t, n) => `${e}-${t} of ${n}`,
  // Task-card stat lines (counts come from the live overview endpoint).
  taskLines: {
    unreadMessages: (e) => `${e} unread ${e === 1 ? "message" : "messages"}`,
    messagesAwaitingReply: (e) => `${e} ${e === 1 ? "message" : "messages"} awaiting reply`,
    unreadComments: (e) => `${e} unread ${e === 1 ? "comment" : "comments"}`,
    commentsAwaitingReply: (e) => `${e} ${e === 1 ? "comment" : "comments"} awaiting reply`,
    designsUnassigned: (e) => `${e} ${e === 1 ? "design" : "designs"} unassigned`,
    designsAssigned: (e) => `${e} ${e === 1 ? "design" : "designs"} assigned to you`
  },
  // Queue view
  queueFilters: {
    all: "All",
    assignedToMe: "Assigned to me",
    unassigned: "Unassigned"
  },
  queueSections: {
    TODO: "To Do",
    IN_PROGRESS: "In Progress",
    PROOF_APPROVED: "Proof Approved",
    COMPLETED: "Order Completed",
    CANCELED: "Canceled"
  },
  queueTooltips: {
    unreadActivity: "Unread activity",
    estimatedDesignTime: "Estimated design time",
    // Per-level urgency copy, mirroring the need-by windows the urgency
    // derives from.
    urgency: {
      RUSH: "This item is needed today",
      HIGH: "This item is needed in 2-3 days",
      MEDIUM: "This item is needed within 5 days",
      LOW: "This item is needed over 5 days from now"
    },
    assignedTo: "Assigned to",
    needBy: "Need by"
  },
  // The filter panel beside search: one row per facet, each control
  // reading "All" until something is picked.
  // The inbox filter chips beside the title.
  inboxFilters: {
    allActive: "All Active",
    unread: "Unread",
    past: "Past"
  },
  inboxFilterButton: "Filter inbox",
  queueFilterPanel: {
    button: "Filter queue",
    all: "All",
    clearAll: "Clear All Filters",
    removeFilter: "Remove filter",
    status: "Status",
    estimatedDesignTime: "Estimated Design Time",
    priority: "Priority",
    product: "Product",
    designService: "Design Service",
    assignedTo: "Assigned To",
    clientName: "Client Name",
    needBy: "Need By",
    // Estimated-time buckets over the summed service minutes.
    timeBuckets: {
      UNDER_1: "<1 hour",
      FROM_1_TO_2: "1-2 hours",
      FROM_2_TO_3: "2-3 hours",
      OVER_3: ">3 hours"
    },
    priorities: {
      LOW: "Low",
      MEDIUM: "Medium",
      HIGH: "High",
      RUSH: "Rush"
    }
  },
  // The MDL editor's designer send-proof button and modal.
  sendProof: {
    button: "Send proof to client",
    title: "Send proof to client",
    noteLabel: "Note",
    noteHelper: "Let the client know what changed.",
    suggestAddOn: "Suggest an add-on",
    cancel: "Cancel",
    send: "Send",
    sending: "Sending…",
    sent: "Proof sent — the client sees it once the pages finish rendering.",
    sentReused: "Proof sent to the client.",
    sentBadge: "Proof sent",
    failed: "Sending the proof failed. Please try again."
  },
  // The Log Time dialog: Harvest-style time entry on an assigned request.
  logTime: {
    title: "Log Time",
    timeSpent: "Time Spent",
    placeholder: "0:05",
    cancel: "Cancel",
    log: "Log",
    logged: "Time logged.",
    invalid: "Enter time as hours (1.5) or h:mm (1:30).",
    service: "Service",
    // "1.5 hours estimated · 2 hours logged · $100.00"
    serviceSummary: (e, t, n) => `${e} estimated · ${t} logged · ${n}`
  },
  // The queue's quick-view drawer: header, unread-alert cards, and CTAs.
  quickView: {
    design: "Design",
    goToPortal: "Go To Portal",
    close: "Close",
    needBy: "Need By",
    sentMessage: (e) => `${e} sent you a message`,
    addedComment: (e) => `${e} added a comment to the proof`,
    addedService: (e) => `${e} added a service`,
    approvedProofOn: (e, t) => `${e} approved the proof on ${t}`,
    addedServiceQuote: (e) => `Additional Design Time at ${e}`,
    serviceQuote: (e, t) => `${e} at ${t}`
  },
  // Shown on the Unassigned view once every open request is claimed.
  queueEmptyUnassigned: {
    title: "No Unassigned Items",
    subtitle: "All open requests have been claimed by a designer.",
    viewMyItems: "View My Items",
    viewAllItems: "View All Items"
  },
  assignToMe: "Assign To Me",
  unassignedLabel: "Unassigned",
  me: "Me",
  reassignToMe: "Reassign To Me",
  reassignLabel: "Reassign",
  // Takeover / hand-off confirmation modal.
  reassignModal: {
    takeoverTitle: "Reassign To Me",
    takeoverBody: (e) => `This will move the request out of ${e}'s queue and into yours. You'll take over the full conversation history, proofs, and attachments.`,
    takeoverBodyUnnamed: "This will move the request into your queue. You'll take over the full conversation history, proofs, and attachments.",
    pickTitle: "Reassign Request",
    pickBody: "Move this request to another designer. They take over the full conversation history, proofs, and attachments.",
    pickLabel: "Assign To",
    confirm: "Reassign",
    cancel: "Cancel",
    success: "Request reassigned",
    failure: "Failed to reassign request"
  },
  searchPlaceholder: "Search",
  estimatedHours: (e) => `${e} ${e === 1 ? "hour" : "hours"}`,
  // My Items workspace
  myItemsView: {
    activity: "Activity",
    clientInfo: "Client Info",
    designedBefore: "You've designed for this client before.",
    viewPastDesigns: "View Past Designs",
    designService: "Design Service",
    pricing: "Pricing",
    item: "Item",
    designServices: "Design Services",
    subtotal: "Subtotal",
    estimatedDesignTime: "Estimated Design Time",
    designTimeUsed: "Design Time Used",
    design: "Design",
    logTime: "Log Time",
    viewDesignDetails: "View Design Details",
    typeMessage: "Type your message...",
    newMessages: "New messages",
    addServices: "Add Services",
    attachPhotosOrDocuments: "Attach Photos Or Documents",
    viewProof: "View Proof",
    messagePreview: (e, t) => `${e}: ${t}`,
    you: "You",
    selectAnItem: "Select an item to open its conversation.",
    noItems: "Nothing is assigned to you yet — claim work from the Queue.",
    submittedItem: (e) => `${e} submitted an item for design`,
    sentProof: (e) => `You sent ${e} a proof`,
    commentedOnProof: (e) => `${e} commented on your proof`,
    youCommented: "You added a comment to the proof",
    viewComment: "View Comment",
    clientDeclinedService: (e, t) => `${e} declined ${t}`,
    approvedProofOn: (e, t) => `${e} approved this proof on ${t}`,
    orderSubmittedOn: (e) => `Order submitted on ${e}`,
    orderCanceledOn: (e) => `Order canceled on ${e}`,
    addedAdditionalTime: (e, t) => `${e} added Additional Design Time at ${t}`,
    sentAddOnSuggestion: (e, t) => `You sent ${e} an add-on suggestion for ${t}`,
    youSentAttachment: "You sent an attachment",
    clientSentAttachment: (e) => `${e} sent an attachment`,
    download: "Download",
    removeAttachment: "Remove",
    attachmentUploadFailed: "Uploading the attachment failed. Please try again.",
    proofReviewed: "Proof Reviewed",
    proofApproved: "Proof Approved",
    estimatedTimeLine: (e) => `Estimated design time: ${e}`,
    clientAddedService: (e, t, n) => `${e} added ${t} at ${n}`,
    caseLabel: (e) => `Case: ${e}`,
    serviceLabel: (e) => `Service: ${e}`,
    // Per-service intake summaries on the submission card, one line per
    // selected service that collected content.
    photoPlacementLine: (e) => `Photo placement: ${e}`,
    themeLine: (e) => `Theme: ${e}`,
    orderOfServiceLine: (e) => `Order of Service: ${e}`,
    layoutChangesLine: (e) => `Layout Changes: ${e}`,
    photoEditsLine: (e, t) => `Photo Edits: ${e} of ${t} photos selected`,
    additionalPhotosLine: (e, t) => `Additional Photos: ${e} of ${t} photos selected`
  },
  // The Design Details modal: the request's product specs plus everything
  // the intake prompts collected.
  // The plus menu beside the designer's chat input.
  composerMenu: {
    suggestAddOns: "Suggest Add-Ons",
    attachFiles: "Attach Photos Or Documents",
    uploadProof: "Upload Proof",
    openMenu: "More actions"
  },
  // The Upload Proof modal: a proof made outside the editor (Signature by
  // Beryl) sent to the client as a PDF.
  uploadProof: {
    title: "Send proof to client",
    proofLabel: "Proof",
    finalLabel: "Final product",
    fileHint: `PDF up to ${d}MB`,
    wrongType: "Only a PDF can be sent.",
    tooLarge: `That PDF is over ${d}MB.`,
    noteLabel: "Note",
    noteHelper: "Let the client know what changed.",
    suggestAddOn: "Suggest an add-on",
    cancel: "Cancel",
    send: "Send",
    sending: "Sending…",
    sent: "Proof sent — the client sees it once the pages finish rendering.",
    uploadFailed: "Uploading the PDF failed. Please try again."
  },
  // The Suggest Add-Ons modal: upsell services picked from chat.
  suggestAddOns: {
    title: "Suggest Add-Ons",
    message: "Message",
    messageHelper: "Let the client know why you're suggesting this.",
    cancel: "Cancel",
    send: "Suggest Add-On",
    sent: "Suggestion sent"
  },
  designDetails: {
    title: "Design Details",
    priceEach: (e) => `${e} Each`,
    design: "Design",
    close: "Close",
    theme: "Theme",
    pageCount: "Page Count",
    quantity: "Quantity",
    needByDate: "Need By Date",
    photoPlacement: "Photo Placement",
    orderOfService: "Order Of Service",
    layoutChanges: "Layout Changes",
    noPlacementNotes: "No placement notes",
    placementSelf: "I'll choose myself",
    placementDesigner: "Designer chooses placement"
  },
  // Activity-row titles, keyed by the customer event that produced them.
  activityTitles: {
    SUBMITTED: (e) => `${e} submitted an item for design`,
    MESSAGE: (e) => `${e} sent you a message`,
    COMMENT: (e) => `${e} commented on your proof`,
    PROOF_APPROVED: (e) => `${e} approved your proof`,
    ADDITIONAL_TIME: (e) => `${e} added Additional Design Time`,
    SERVICE_ADDED: (e) => `${e} added a service`,
    SERVICE_DECLINED: (e) => `${e} declined a service`
  }
}, be = {
  /** The customer's personalize access (funeral-home user editor). */
  FH_ADMIN: "FH_ADMIN",
  /** Design staff: the full admin-level editor. */
  DESIGNER: "DESIGNER",
  /** The order's never-expiring QC token: full admin-level editor. */
  QC: "QC"
}, u = "access", He = "token", p = ["token", "fh_admin"], we = "qc_shadow", Be = {
  MESSENGER: "messenger-user",
  FH: "fh-user"
}, $e = (e) => p.includes(
  new URLSearchParams(e).get(u) ?? ""
), Ye = "x-edit-token", Ve = {
  role: "editTokenRole",
  scopeOrderProductId: "editTokenScopeProductId",
  // The raw token, kept for designer and QC sessions: it is sent beside
  // x-order on each request, so the backend reads the session's role from
  // it, and it authenticates a designer's send-proof calls.
  token: "editToken"
}, g = {
  BAD_REQUEST: "BAD_REQUEST",
  UNAUTHORIZED: "UNAUTHORIZED",
  FORBIDDEN: "FORBIDDEN",
  NOT_FOUND: "NOT_FOUND",
  CONFLICT: "CONFLICT",
  PRECONDITION_FAILED: "PRECONDITION_FAILED",
  GONE: "GONE",
  TOO_MANY_REQUESTS: "TOO_MANY_REQUESTS",
  UNSUPPORTED_IMAGE_FORMAT: "UNSUPPORTED_IMAGE_FORMAT",
  FILE_TOO_LARGE: "FILE_TOO_LARGE",
  IMAGE_IN_USE_BY_LAYOUT: "IMAGE_IN_USE_BY_LAYOUT",
  // A reorder would copy text boxes onto an order whose funeral home may not
  // hold them, so nothing was added.
  LAYOUT_TEXT_NOT_AVAILABLE: "LAYOUT_TEXT_NOT_AVAILABLE",
  // The AI image edits switch (Site Settings > AI Image Edits in M3) is off,
  // so no background removal or Enhance may start or be accepted.
  AI_IMAGE_EDITS_DISABLED: "AI_IMAGE_EDITS_DISABLED",
  INTERNAL_SERVER_ERROR: "INTERNAL_SERVER_ERROR"
}, ke = "order_page_gone", xe = "order_page_turned_over", qe = "lotus_funeral_home_not_enabled", Qe = "lotus_global_template_refused", ze = "layout_saver_has_no_funeral_home", Ke = "dignity direct", Xe = "M3", We = "MDL", Ze = "https://videos.tukios.com", Je = "6f2aa94b-641c-4ad7-a01a-12817c30a52c", je = "liminal-touch", et = "f7fb0a28-824e-4916-8d52-1c1f689b9bcc", tt = {
  image: "image",
  text: "text",
  shape: "shape",
  line: "line",
  qrCode: "qrCode",
  editorTextBox: "editorTextBox"
}, nt = 96, st = "https://tribute.liminal-touch.com", at = 1e4, ot = {
  INVITED: "invited",
  NOT_REACHED: "not_reached",
  IN_PROGRESS: "in_progress",
  AWAITING_CONFIRMATION: "awaiting_confirmation",
  COMPLETE: "complete",
  CANCELLED: "cancelled"
}, N = "liminalTouchCreate", it = (e) => `${N}:${e}`, rt = {
  attempts: 10,
  backoff: { type: "exponential", delay: 2e3 },
  removeOnComplete: !0,
  removeOnFail: !0
}, dt = "liminal-touch-qr-code", _t = {
  FIRST_NAME: "deceased.first_name",
  LAST_NAME: "deceased.last_name",
  DATE_OF_BIRTH: "deceased.date_of_birth",
  DATE_OF_DEATH: "deceased.date_of_death",
  SERVICE_DATE: "service_date",
  FAMILY_CONTACT: "family.contact"
}, lt = "LIMINAL_TOUCH_DETAILS_MISSING", ct = "LIMINAL_TOUCH_CONTACT_LOCKED", Et = "LIMINAL_TOUCH_CONTACT_INVALID", At = "LIMINAL_TOUCH_SKIP_ENHANCEMENT_REFUSED", mt = "LIMINAL_TOUCH_QR_ALREADY_ADDED", It = 10 * 6e4, Tt = /^[A-Za-z0-9_-]{3,64}$/, Ot = /^\+[1-9]\d{7,14}$/, St = 100, ut = {
  ERROR: "error",
  WARN: "warn",
  INFO: "info",
  DEBUG: "debug"
}, pt = {
  CLICK: "click",
  AUTH: "auth",
  API: "api",
  NAVIGATION: "navigation",
  ERROR: "error",
  PERFORMANCE: "performance",
  SAVE: "save",
  REMOVE: "remove",
  EDIT: "edit",
  CREATE: "create",
  SEARCH: "search",
  CANCEL: "cancel",
  SUBMIT: "submit",
  CLOSE: "close",
  OPEN: "open",
  TOGGLE: "toggle",
  SHOW: "show",
  HIDE: "hide",
  INSERT: "insert",
  FORMAT: "format",
  DISCREPANCY: "discrepancy"
}, gt = 47, Nt = "proofShareFinalize", ft = "Screenshot generation failed", Dt = {
  removeOnComplete: !0,
  attempts: 3,
  backoff: {
    type: "exponential",
    delay: 2e3
  }
}, Lt = [
  /Invalid call to runtime\.sendMessage/i,
  /Tab not found/i,
  /Extension context invalidated/i,
  // Meta (Facebook / Instagram) in-app browser injected telemetry. Its Android
  // WebView Java↔JS bridge object is garbage-collected on page unload, so the
  // injected beacon call rejects with "Java object is gone". Not an app bug.
  // Message-level backstop for the frameless case (denyUrls can't see those).
  // Origin issue: Sentry MDL-FRONTEND-EE.
  /Java object is gone/i,
  /Error invoking .*enableButtonsClickedMetaDataLogging/i
], Rt = [
  /^chrome-extension:\/\//,
  /^moz-extension:\/\//,
  /^safari-(web-)?extension:\/\//,
  // Meta in-app browser injected scripts load under the iabjs:// scheme
  // (e.g. iabjs://navigation_performance_logger_android). Dropping the scheme
  // filters the whole class of Facebook / Instagram in-app-browser noise by
  // stack frame. Origin issue: Sentry MDL-FRONTEND-EE.
  /^iabjs:\/\//
], ht = {
  autocorrect: "off",
  autocapitalize: "off",
  spellcheck: "false",
  writingsuggestions: "false",
  translate: "no",
  "data-gramm": "false",
  "data-gramm_editor": "false",
  "data-enable-grammarly": "false"
}, Ct = {
  PLAIN: "PLAIN",
  PREPRINTED: "PREPRINTED"
}, Pt = {
  QUEUED: "QUEUED",
  PROCESSING: "PROCESSING",
  COMPLETED: "COMPLETED",
  FAILED: "FAILED"
}, Mt = {
  queued: "queued",
  processing: "processing",
  completed: "completed",
  failed: "failed"
}, yt = {
  BG_REMOVAL: "BG_REMOVAL",
  UPSCALE: "UPSCALE"
}, Ut = {
  bg_removal: "bg_removal",
  upscale: "upscale"
}, f = {
  DAILY_CAP_REACHED: "DAILY_CAP_REACHED",
  MODERATION_BLOCKED: "MODERATION_BLOCKED",
  SPEND_LIMIT: "SPEND_LIMIT",
  NOT_CONFIGURED: "NOT_CONFIGURED",
  MODEL_ERROR: "MODEL_ERROR",
  ENQUEUE_FAILED: "ENQUEUE_FAILED",
  ASPECT_UNSUPPORTED: "ASPECT_UNSUPPORTED",
  AI_IMAGE_EDITS_DISABLED: g.AI_IMAGE_EDITS_DISABLED
}, D = new Set(
  Object.values(f)
), Ft = (e) => D.has(e), Gt = {
  IN_QUEUE: "IN_QUEUE",
  GENERATING: "GENERATING",
  COMPLETE: "COMPLETE",
  TIMEOUT: "TIMEOUT",
  ERROR: "ERROR",
  PROOF_ONLY: "PROOF_ONLY"
}, vt = {
  in_queue: "in_queue",
  generating: "generating",
  complete: "complete",
  timeout: "timeout",
  error: "error",
  proof_only: "proof_only"
}, s = {
  INITIALIZATION: "INITIALIZATION",
  DATA_FETCHING: "DATA_FETCHING",
  PAGE_ACQUISITION: "PAGE_ACQUISITION",
  PAGE_SETUP: "PAGE_SETUP",
  NAVIGATION: "NAVIGATION",
  CONTENT_LOADING: "CONTENT_LOADING",
  PDF_GENERATION: "PDF_GENERATION",
  GHOSTSCRIPT_PROCESSING: "GHOSTSCRIPT_PROCESSING",
  S3_UPLOAD: "S3_UPLOAD",
  FINALIZATION: "FINALIZATION"
}, bt = {
  [s.INITIALIZATION]: { start: 0, end: 5 },
  [s.DATA_FETCHING]: { start: 5, end: 15 },
  [s.PAGE_ACQUISITION]: { start: 15, end: 20 },
  [s.PAGE_SETUP]: { start: 20, end: 30 },
  [s.NAVIGATION]: { start: 30, end: 45 },
  [s.CONTENT_LOADING]: { start: 45, end: 60 },
  [s.PDF_GENERATION]: { start: 60, end: 70 },
  [s.GHOSTSCRIPT_PROCESSING]: { start: 70, end: 80 },
  [s.S3_UPLOAD]: { start: 80, end: 95 },
  [s.FINALIZATION]: { start: 95, end: 100 }
}, Ht = {
  EDITING: "EDITING",
  PROOF_SENT: "PROOF_SENT",
  FINALIZED: "FINALIZED",
  CLOSED: "CLOSED"
}, wt = {
  editing: "editing",
  proof_sent: "proof_sent",
  finalized: "finalized",
  closed: "closed"
}, Bt = {
  pdfProduct: "pdfProduct",
  pdfProofProduct: "pdfProofProduct",
  finals: "finals",
  proofs: "proofs",
  pdfPrint: "pdfPrint"
}, i = (e) => e, L = (e) => e, R = {
  EN: "EN",
  ES: "ES",
  FR: "FR"
}, $t = "en", Yt = i({
  EN: "en",
  ES: "es",
  FR: "fr"
}), Vt = i({
  EN: "English",
  ES: "Spanish",
  FR: "French"
}), kt = i({
  EN: "English",
  ES: "Español",
  FR: "Français"
}), h = L({
  EN: { value: "EN", label: "English" },
  ES: { value: "ES", label: "Spanish" },
  FR: { value: "FR", label: "French" }
}), xt = Object.values(R), qt = Object.values(h), C = [
  "photoEdits",
  "additionalPhotos",
  "placement",
  "review"
], o = 30, l = (e) => Math.max(
  1,
  Math.ceil(
    (e ?? o) / o
  )
), Qt = 2500, zt = (e) => {
  const t = l(e.durationMinutes), n = e.unitPriceCents ?? Math.round(e.feeCents / t);
  return { units: t, basePriceCents: n, totalCents: t * n };
}, Kt = (e) => {
  const t = e.loggedMinutes > 0 ? Math.ceil(e.loggedMinutes / o) : l(e.durationMinutes);
  return { units: t, totalCents: t * e.unitPriceCents };
}, P = ["COMPLETED", "CANCELED"], M = (e) => e != null && P.includes(e), y = (e) => e === "PROOF_APPROVED", U = 3, F = 5, Xt = (e) => e.length > 0 && e.length <= U && e.every((t) => t.comment.trim().length > 0), Wt = (e) => e.length > 0 && e.length <= F, Zt = {
  photoEdits: "IMAGE_SELECTION",
  additionalPhotos: "IMAGE_SELECTION",
  placement: "IMAGE_SELECTION",
  review: "CASE_REVIEW"
}, G = [
  "IMAGE_SELECTION",
  "CASE_REVIEW",
  "IN_DESIGN"
], v = (e) => G.includes(e), Jt = (e) => !y(e.designRequestStatus) && (v(e.status) || e.designRequestStatus != null && !M(e.designRequestStatus)), b = {
  prompt: null,
  steps: () => ["review"]
}, _ = {
  "Standard Theme Design": {
    prompt: "imagePlacement",
    steps: ({ imagePlacementChoice: e }) => e === "self" ? ["placement", "review"] : ["review"]
  },
  // The designer invents the background, so the theme selector is replaced by
  // the custom-theme brief; Continue goes straight to the review modal.
  "Custom Theme Design": {
    prompt: "customTheme",
    steps: () => ["review"]
  },
  // The order-of-service content rides in as a document upload or typed
  // text below the case dropdown; Continue goes straight to review.
  "Order of Service Partner": {
    prompt: "orderOfService",
    steps: () => ["review"]
  },
  // The requested layout adjustments ride in as free text below the case
  // dropdown; Continue goes straight to review.
  "Layout Partner": {
    prompt: "layoutChanges",
    steps: () => ["review"]
  },
  // Photo selections + edit comments are normally collected on the product
  // page; the modal step only runs when the customer hits Continue without
  // finishing them.
  "Photograph Editor": {
    prompt: "photoEdits",
    steps: ({ photoEditsComplete: e }) => e ? ["review"] : ["photoEdits", "review"]
  },
  // The extra photos (uploaded through the case-image pipeline or picked
  // from existing case images) are normally collected on the product page;
  // the modal step only runs when Continue is hit without any added.
  "Additional Photos": {
    prompt: "additionalPhotos",
    steps: ({ additionalPhotosComplete: e }) => e ? ["review"] : ["additionalPhotos", "review"]
  }
}, c = "Signature by Beryl", jt = (e) => e.some(
  (t) => t.toLowerCase() === c.toLowerCase()
), H = {
  [c]: "Standard Theme Design",
  "Design my product using a standard theme": "Standard Theme Design",
  "Design my product using a custom theme": "Custom Theme Design",
  "Add an order of service": "Order of Service Partner",
  "Design my layouts": "Layout Partner",
  "Edit my photos": "Photograph Editor",
  "Add more photos": "Additional Photos"
}, w = new Map([
  ...Object.entries(_).map(
    ([e, t]) => [e.toLowerCase(), t]
  ),
  ...Object.entries(H).map(
    ([e, t]) => [e.toLowerCase(), _[t]]
  )
]), r = (e) => w.get(e.toLowerCase()) ?? b, en = (e) => r(e).prompt, tn = (e) => {
  const t = /* @__PURE__ */ new Set();
  return e.forEach((n) => {
    const a = r(n).prompt;
    a && t.add(a);
  }), t;
}, nn = (e, t) => {
  const n = /* @__PURE__ */ new Set();
  return e.forEach((a) => {
    r(a).steps(t).forEach((E) => n.add(E));
  }), C.filter((a) => n.has(a));
}, sn = [
  "unassigned",
  "assigned",
  "approved",
  "completed",
  "canceled"
], an = "/designer/custom-designs/queue", on = {
  user: "USER",
  superAdmin: "SUPER_ADMIN",
  corporationAdmin: "CORPORATION_ADMIN"
}, B = (e) => e.trim().replace(/^['"]|['"]$/g, ""), rn = (e) => B(e.split(",")[0] ?? ""), dn = "#000000", _n = 2, ln = 1, cn = [
  "--no-sandbox",
  "--disable-web-security",
  "--font-render-hinting=none",
  "--disable-dev-shm-usage",
  "--disable-gpu",
  "--disable-setuid-sandbox",
  "--no-first-run",
  "--no-zygote",
  '--js-flags="--max-old-space-size=4096"',
  "--disable-extensions",
  "--disable-background-networking",
  "--disable-default-apps",
  "--disable-sync",
  "--disable-translate",
  "--mute-audio",
  "--disable-component-update",
  "--disable-background-timer-throttling",
  "--disable-renderer-backgrounding",
  "--disable-backgrounding-occluded-windows"
], En = 9e4, An = {
  printBackground: !0
}, mn = "/usr/share/fonts/google-fonts:/usr/share/fonts/editor-fonts:/usr/share/fonts/root-fonts:/usr/share/fonts", In = [
  "-dSAFER",
  "-dBATCH",
  "-dNOPAUSE",
  "-dNOCACHE",
  "-sDEVICE=pdfwrite",
  "-dPreserveAnnots=false",
  "-dAutoRotatePages=/None"
], Tn = /^[A-Za-z0-9_-]*$/, On = [
  // Design assets: theme art, backgrounds and product images
  "bassmollett-designassets.s3.us-west-2.amazonaws.com",
  // Case images: photos of the deceased and their Pintura edits
  "bassmollett-caseimages.s3.us-west-2.amazonaws.com",
  // Uploads: images funeral homes upload into the editor
  "bassmollett-uploads.s3.us-west-2.amazonaws.com",
  // Dignity verse images
  "dignity-verses.s3.us-west-2.amazonaws.com",
  // m3 dynamic layout assets: layout images m3 page sets name
  "m3-layout-assets.s3.us-west-2.amazonaws.com",
  // MDL dynamic layout assets: layout images MDL page sets name
  "dignity-layout-assets.s3.us-west-2.amazonaws.com",
  // Path-style S3 host: the bucket is the path's first segment, so a request
  // here is allowed only for a bucket in RENDER_FETCH_ALLOWED_S3_BUCKETS
  "s3-us-west-2.amazonaws.com",
  // Third-party placeholder images stored page content names at scale
  "placehold.co",
  // Third-party placeholder images, the older service
  "via.placeholder.com"
], Sn = "s3-us-west-2.amazonaws.com", un = [
  // Case images, as stored content and REACT_APP_S3BUCKET_CASE_IMAGES name them
  "bassmollett-caseimages",
  // Uploads, as stored content and REACT_APP_S3BUCKET_UPLOADS name them
  "bassmollett-uploads",
  // Funeral home logos, built from REACT_APP_S3BUCKET_FH_LOGOS
  "bassmollett-funeralhomelogos",
  // Theme backgrounds and watermarks, built from REACT_APP_S3BUCKET_THEME_IMAGES
  "bassmollett-themeimages",
  // Floral images, built from REACT_APP_S3BUCKET_FLORAL_PIX
  "bassmollett-floralpix"
], pn = [0, 3], gn = 96 / 72, $ = "data-fonts-contract", Y = "1", Nn = {
  [$]: Y
}, fn = 300 * 1e3, Dn = 600 * 1e3, Ln = "Font failed to load";
export {
  A as AI_ALTERATION_KINDS,
  x as AI_ALTERATION_LABEL,
  k as AI_ALTERATION_MAX_PRICE_CENTS,
  m as AI_ALTERATION_OPTION_ID,
  V as AI_ALTERATION_UNIT_PRICE_CENTS,
  q as AI_IMAGE_EDITS_CUSTOMIZATION_ID,
  Re as AUTH0_GTY_CLIENT_CREDENTIALS,
  Ct as BACKGROUND_TYPE,
  gt as BANNER_PROOF_PDF_MIN_PAGE_HEIGHT_INCHES,
  se as CASE_IMAGE_JOB_MAX_POLLS,
  ne as CASE_IMAGE_JOB_POLL_INTERVAL_MS,
  Pt as CASE_IMAGE_JOB_STATUS_KEY,
  Mt as CASE_IMAGE_JOB_STATUS_VALUE,
  Z as CASE_IMAGE_MAX_HEIGHT,
  J as CASE_IMAGE_MAX_QUALITY,
  W as CASE_IMAGE_MAX_WIDTH,
  f as CASE_IMAGE_VARIANT_ERROR_CODE,
  yt as CASE_IMAGE_VARIANT_KIND_KEY,
  Ut as CASE_IMAGE_VARIANT_KIND_VALUE,
  ae as CASE_IMAGE_VARIANT_POLL_INTERVAL_MS,
  fe as CASE_MODAL_TAB_KEYS,
  P as CLOSED_DESIGN_REQUEST_STATUSES,
  Dn as COMBINED_PDF_GENERATION_TIMEOUT_MS,
  gn as CSS_PX_PER_PT,
  dn as DEFAULT_FONT_COLOR,
  $t as DEFAULT_LOCALE_CODE,
  he as DESIGNER_ACTIVITY_POLL_MS,
  Ce as DESIGNER_CHAT_POLL_MS,
  G as DESIGNER_FLOW_STATUSES,
  C as DESIGNER_FLOW_STEP_ORDER,
  _ as DESIGNER_OPTION_FLOWS,
  H as DESIGNER_OPTION_LABEL_ALIASES,
  ve as DESIGNER_SPACE_LABELS,
  an as DESIGNER_SPACE_QUEUE_PATH,
  Zt as DESIGNER_STEP_STATUS,
  Pe as DESIGN_CLOSED_AT_FORMAT,
  Fe as DESIGN_NOTIFY_DELAY_MS,
  T as DESIGN_REQUEST_NOTIFY_JOB,
  sn as DESIGN_REQUEST_QUEUE_BUCKETS,
  o as DESIGN_TIME_UNIT_MINUTES,
  Qt as DESIGN_TIME_UNIT_PRICE_CENTS,
  Ke as DIGNITY_DIRECT,
  _n as EDITOR_ACTIVE_BORDER_WIDTH,
  ln as EDITOR_INACTIVE_BORDER_WIDTH,
  Be as EDITOR_USER_ROLE,
  u as EDIT_SESSION_ACCESS_PARAM,
  He as EDIT_SESSION_TOKEN_ACCESS,
  p as EDIT_SESSION_TOKEN_ACCESS_VALUES,
  Ye as EDIT_TOKEN_HEADER,
  be as EDIT_TOKEN_ROLE,
  Ve as EDIT_TOKEN_STORAGE_KEYS,
  g as ERROR_CODE,
  pt as EventCategory,
  Ln as FONT_LOAD_FAILED_REASON,
  In as GS_FLATTEN_FLAGS,
  mn as GS_FONTPATH,
  K as IMAGE_MIME_WILDCARD,
  oe as IMAGE_PLACEHOLDER_REGEX,
  X as IMAGE_QUALITY_BANNER_PPI_THRESHOLD,
  I as IMAGE_QUALITY_PAPER_PPI_THRESHOLD,
  Le as JWT_SHAPE,
  cn as LAUNCH_FLAGS,
  En as LAUNCH_TIMEOUT_MS,
  ze as LAYOUT_SAVER_HAS_NO_FUNERAL_HOME_REASON,
  we as LEGACY_QC_SHADOW_ACCESS,
  Tt as LIMINAL_TOUCH_CASE_ID_PATTERN,
  Et as LIMINAL_TOUCH_CONTACT_INVALID,
  ct as LIMINAL_TOUCH_CONTACT_LOCKED,
  N as LIMINAL_TOUCH_CREATE_JOB,
  rt as LIMINAL_TOUCH_CREATE_JOB_OPTIONS,
  st as LIMINAL_TOUCH_DEFAULT_BASE_URL,
  lt as LIMINAL_TOUCH_DETAILS_MISSING,
  Ot as LIMINAL_TOUCH_E164_PATTERN,
  St as LIMINAL_TOUCH_NAME_MAX_LENGTH,
  mt as LIMINAL_TOUCH_QR_ALREADY_ADDED,
  dt as LIMINAL_TOUCH_QR_FILE_PREFIX,
  It as LIMINAL_TOUCH_QR_UPLOAD_LIVE_MS,
  at as LIMINAL_TOUCH_REQUEST_TIMEOUT_MS,
  _t as LIMINAL_TOUCH_REQUIRED_DETAIL,
  At as LIMINAL_TOUCH_SKIP_ENHANCEMENT_REFUSED,
  ot as LIMINAL_TOUCH_STATUS,
  R as LOCALE,
  Vt as LOCALE_DISPLAY_NAMES,
  Yt as LOCALE_MAP,
  qt as LOCALE_OPTIONS,
  h as LOCALE_OPTIONS_MAP,
  kt as LOCALE_TRANSLATED_DISPLAY_NAMES,
  xt as LOCALE_VALUES,
  qe as LOTUS_FUNERAL_HOME_NOT_ENABLED_CODE,
  Qe as LOTUS_GLOBAL_TEMPLATE_REFUSED_CODE,
  ut as LogLevel,
  Xe as M3,
  je as M3_LIMINAL_TOUCH_CATEGORY_SHORT_CODE,
  Dt as M3_QUEUE_DEFAULT_JOB_OPTIONS,
  et as M3_SPECIALTY_CARDS_CATEGORY_ID,
  Je as M3_TUKIOS_CATEGORY_ID,
  F as MAX_ADDITIONAL_PHOTOS,
  Ne as MAX_FILLED_CASE_IMAGES,
  U as MAX_PHOTO_EDITS,
  z as MAX_UPLOAD_FILE_SIZE,
  We as MDL,
  ee as MIO_ANALYSIS_HEIGHT,
  te as MIO_ANALYSIS_QUALITY,
  j as MIO_ANALYSIS_WIDTH,
  ie as NON_EDITABLE_IMAGE_SUBTYPES,
  ke as ORDER_PAGE_GONE_CODE,
  xe as ORDER_PAGE_TURNED_OVER_CODE,
  tt as PAGE_ITEM_TYPES,
  $ as PDF_FONTS_CONTRACT_ATTR,
  Nn as PDF_FONTS_CONTRACT_MARK,
  Y as PDF_FONTS_CONTRACT_VERSION,
  fn as PDF_GENERATION_TIMEOUT_MS,
  Tn as PDF_KEY_SEGMENT_PATTERN,
  Bt as PDF_PROCESSOR_TYPE,
  bt as PDF_PROGRESS_STAGES,
  s as PDF_PROGRESS_STAGE_NAMES,
  Gt as PDF_STATUS_KEY,
  vt as PDF_STATUS_VALUE,
  An as PRINT_TO_PDF_BASE,
  nt as PRODUCT_DEFAULT_DPI,
  Ue as PROOF_NOTE_MAX_LENGTH,
  S as PROOF_PDF_MAX_BYTES,
  d as PROOF_PDF_MAX_MB,
  Me as PROOF_PDF_MAX_PAGES,
  O as PROOF_PDF_RASTERIZE_JOB,
  Nt as PROOF_SHARE_FINALIZE_JOB,
  pn as QPDF_SUCCESS_EXIT_CODES,
  On as RENDER_FETCH_ALLOWED_HOSTS,
  un as RENDER_FETCH_ALLOWED_S3_BUCKETS,
  Sn as RENDER_FETCH_PATH_STYLE_S3_HOST,
  ft as SCREENSHOT_JOB_FAILED_REASON,
  Rt as SENTRY_DENY_URLS,
  Lt as SENTRY_IGNORE_ERRORS,
  c as SIGNATURE_BY_BERYL_LABEL,
  Ht as STATUS_KEY,
  wt as STATUS_VALUE,
  ht as TEXT_ENTRY_INTENT_ATTRIBUTES,
  Ze as TUKIOS_API_ORIGIN,
  _e as UPSCALE_MAX_ASPECT_RATIO,
  ce as UPSCALE_MODEL_TIMEOUT_MS,
  le as UPSCALE_TARGET_MAX_EDGE_PX,
  de as UPSCALE_TARGET_MAX_PIXELS,
  re as UPSCALE_TARGET_PPI,
  Q as aiAlterationKindForOptionId,
  De as applicationTypes,
  Ee as caseFormSections,
  Oe as caseFormSectionsLabels,
  Ge as designNotifyJobId,
  l as designTimeUnits,
  zt as designerServiceLinePrice,
  rn as firstFamily,
  ue as formFieldAllowedInputs,
  Te as formFieldKeys,
  Ie as formFieldTypes,
  jt as hasSignatureByBerylService,
  Wt as isAdditionalPhotosComplete,
  Ft as isCaseImageVariantErrorCode,
  M as isClosedDesignRequestStatus,
  v as isDesignerFlowStatus,
  Jt as isDesignerManagedLine,
  Xt as isPhotoEditsComplete,
  y as isProofApprovedDesignRequestStatus,
  $e as isTokenizedEditSession,
  it as liminalTouchCreateJobId,
  Ae as nameComponents,
  me as nameComponentsFormatted,
  pe as newObjects,
  en as promptForOption,
  tn as promptsForOptions,
  ye as proofPdfRasterizeJobId,
  Kt as serviceTimeCharge,
  ge as specialFieldBehaviors,
  nn as stepsForOptions,
  Se as typeKeys,
  on as userTypes
};
